// Vehicle data reducers
export type InputActionType =
  | "BRAND"
  | "MODEL"
  | "COLOR"
  | "PLATE"
  | "DESCRIPTION"
  | "ID";

export type InputAction = {
  type: InputActionType;
  payload: string;
};

export type VehicleTabData = {
  brand: string;
  model: string;
  color: string;
  plate: string;
  description: string;
  id: string;
};

export const INITIAL_VEHICLE_STATE: VehicleTabData = {
  brand: "",
  color: "",
  description: "",
  model: "",
  plate: "",
  id: "",
};

export function dataReducer(
  state: VehicleTabData = INITIAL_VEHICLE_STATE,
  action: InputAction
): VehicleTabData {
  switch (action.type) {
    case "BRAND":
      return { ...state, brand: action.payload };
    case "COLOR":
      return { ...state, color: action.payload };
    case "DESCRIPTION":
      return { ...state, description: action.payload };
    case "PLATE":
      return { ...state, plate: action.payload };
    case "MODEL":
      return { ...state, model: action.payload };
    case "ID":
      return { ...state, id: action.payload };
    default:
      return state;
  }
}
